export default {
  light: {
    fore: '#000000',
    back: '#FFFFFF',
    primary: '#4793DD',
    secondary: '#EB5033',
    highlight: '#D157F9',
    lowlight: '#AAAAAA',
    glass: 'rgb(255 255 255 / 60%)',
    fire: 'red',
    air: 'goldenrod',
    water: 'blue',
    earth: 'saddlebrown'
  },
  dark: {
    fore: '#FFFFFF',
    back: '#000000',
    primary: '#5faefc',
    secondary: '#fc664b',
    highlight: '#d150fc',
    lowlight: '#777777',
    glass: 'rgb(0 0 0 / 60%)',
    fire: 'tomato',
    air: 'lemonchiffon',
    water: 'skyblue',
    earth: 'sandybrown'
  }
}
